import * as React from 'react';
import { SVGProps } from 'react';

const FileIconPngSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      opacity={0.6}
      d="M6 13h3v3H6v-3Zm0 6h3v3H6v-3Zm6-6h3v3h-3v-3Zm0 6h3v3h-3v-3Zm-3-3h3v3H9v-3Zm0 6h3v3H9v-3Zm6-6h3v3h-3v-3Zm0 6h3v3h-3v-3Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.8 4v.24c.207-.16.473-.24.8-.24h.7c.587 0 1.017.127 1.29.38.273.247.41.653.41 1.22v1.8c0 .56-.14.967-.42 1.22-.273.253-.7.38-1.28.38H6.01v2H5V4h.8Zm.85 1c-.22 0-.383.06-.49.18a.53.53 0 0 0-.16.37L6.01 8h1.24c.247 0 .433-.057.56-.17.127-.113.19-.273.19-.48v-1.7c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17h-.6ZM11 4v.24c.207-.16.473-.24.8-.24h.6c.54 0 .94.127 1.2.38.267.253.4.66.4 1.22V9h-1V5.65c0-.2-.06-.357-.18-.47-.113-.12-.27-.18-.47-.18h-.7c-.22 0-.383.06-.49.18a.53.53 0 0 0-.16.37V9h-1V4h1Zm6.25 5c.293 0 .543-.067.75-.2V9c0 1 0 1-1 1h-1.5v1H18a1 1 0 0 0 1-1V4h-2.3c-.58 0-1.01.127-1.29.38-.273.253-.41.66-.41 1.22v1.8c0 .567.137.977.41 1.23.273.247.703.37 1.29.37h.55Zm.59-1.17c-.107.113-.27.17-.49.17h-.6c-.247 0-.433-.057-.56-.17-.127-.113-.19-.273-.19-.48v-1.7c0-.207.063-.367.19-.48.127-.113.313-.17.56-.17H18v2.45c0 .133-.053.26-.16.38Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconPngSizeS;
